/*
 * Litte — barra inferior del banner + cotizador
 *
 * Dos piezas independientes que viven en el bloque "Banner Casos de Uso":
 *   1. Puntos de paginacion sincronizados con el carrusel de slides.
 *   2. Asistente de 3 pasos que arma un mensaje de WhatsApp con las respuestas.
 *
 * Contrato de marcado:
 *   [data-uc-app="<block.id>"]        raiz (envuelve carrusel + barra)
 *     [data-lc-track]                 pista del carrusel (la comparte litte-carousel.js)
 *       [data-uc-idx="N"]             cada slide; los clones del carrusel heredan el atributo
 *     [data-uc-open]                  boton que abre el cotizador
 *     [data-uc-go="N"]                punto de paginacion
 *   #ucq-<block.id>[data-uc-modal]    modal, fuera del contenedor con overflow
 *     [data-uc-phone] [data-uc-intro] base de WhatsApp y saludo del mensaje
 *     [data-uc-step="1..4"]           pasos; el 4 es el resultado
 *       [data-uc-key]                 etiqueta de esa respuesta en el mensaje
 *     [data-uc-pick="N"]              opcion; lleva data-uc-val y (paso 1) data-uc-kit
 *     [data-uc-sum] [data-uc-kitlist] [data-uc-wa] [data-uc-back] [data-uc-close]
 */
(function () {
  'use strict';
  if (window.LitteQuoter) return;

  var SCROLL_WAIT = 90;
  var RESIZE_WAIT = 160;
  var PICK_WAIT = 200;
  var CLOSE_WAIT = 260;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  // Analitica opcional: si no hay dataLayer ni fbq, no hace nada.
  function track(name, params) {
    var p = params || {};
    try {
      if (window.dataLayer && window.dataLayer.push) {
        var payload = { event: name };
        for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) payload[k] = p[k]; }
        window.dataLayer.push(payload);
      }
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, p);
    } catch (e) { /* nunca romper la UI por un pixel */ }
  }

  function setupApp(app) {
    if (app.__ucReady) return;
    app.__ucReady = true;

    var id = app.getAttribute('data-uc-app');
    var modal = document.getElementById('ucq-' + id);
    var cleaners = [];

    bindAutoplayPause(app, cleaners);
    bindDots(app, cleaners);
    bindSlideTracking(app);
    if (modal) bindQuoter(app, modal, id, cleaners);

    app.__ucCleanup = function () {
      each(cleaners, function (fn) { fn(); });
      cleaners = [];
    };
  }

  /* ---------- Pausa del autoplay ----------
   * litte-carousel.js solo engancha pausa/reanudacion a [data-lc-root], y la barra
   * es hermana suya: sin esto la rotacion pisa al usuario mientras apunta a un punto.
   * Ademas, el primer toque o clic en un punto la detiene de forma definitiva, que es
   * el mecanismo de parada que pide WCAG 2.2.2.
   */
  function bindAutoplayPause(app, cleaners) {
    var root = app.querySelector('[data-lc-root]');
    if (!root || !root.hasAttribute('data-lc-autoplay')) return;
    var bar = app.querySelector('.lp-ucbar');

    function fire(name) {
      var ev;
      try { ev = new Event(name); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent(name, false, false); }
      root.dispatchEvent(ev);
    }
    function pause(sticky) { if (sticky) app.__ucStop = true; fire('mouseenter'); }
    function resume() { if (!app.__ucStop) fire('mouseleave'); }

    app.__ucPause = pause;

    if (bar) {
      bar.addEventListener('mouseenter', function () { pause(false); });
      bar.addEventListener('mouseleave', resume);
      bar.addEventListener('focusin', function () { pause(false); });
      bar.addEventListener('focusout', resume);
    }
    // A proposito NO se detiene con touchstart: un simple scroll que arranque sobre el
    // banner pararia la rotacion. El mecanismo de parada son los puntos (ver bindDots).

    cleaners.push(function () { app.__ucStop = false; });
  }

  /* ---------- Analitica de la barra y los slides ---------- */
  function bindSlideTracking(app) {
    var tr = app.querySelector('[data-lc-track]');
    if (tr) {
      tr.addEventListener('click', function (e) {
        var el = e.target;
        while (el && el !== tr && !(el.classList && el.classList.contains('lp-case'))) el = el.parentNode;
        if (!el || el === tr) return;
        track('litte_slide_click', {
          slide: el.getAttribute('data-uc-idx') || '',
          destino: el.getAttribute('href') || ''
        });
      });
    }
    var wa = app.querySelector('.lp-ucbtn--s');
    if (wa) wa.addEventListener('click', function () { track('litte_wa_click', { origen: 'barra' }); });
  }

  /* ---------- Puntos de paginacion ---------- */
  function bindDots(app, cleaners) {
    var track = app.querySelector('[data-lc-track]');
    var dots = app.querySelectorAll('[data-uc-go]');
    if (!track || !dots.length) return;

    // Misma medida que usa el carrusel: posicion del item dentro del contenido scrollable.
    function posIn(el) {
      return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function paint(n) {
      each(dots, function (d) {
        var on = parseInt(d.getAttribute('data-uc-go'), 10) === n;
        if (on) { d.classList.add('is-on'); d.setAttribute('aria-current', 'true'); }
        else { d.classList.remove('is-on'); d.removeAttribute('aria-current'); }
      });
    }

    // El slide mas cercano al borde izquierdo manda. Sirve igual si es un clon,
    // porque cloneNode copia data-uc-idx.
    function nearest(want) {
      var kids = track.children, best = null, bd = Infinity, sl = track.scrollLeft;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el.nodeType !== 1) continue;
        var raw = el.getAttribute('data-uc-idx');
        if (raw === null) continue;
        if (want != null && parseInt(raw, 10) !== want) continue;
        var d = Math.abs(posIn(el) - sl);
        if (d < bd) { bd = d; best = el; }
      }
      return best;
    }

    function sync() {
      var el = nearest(null);
      if (el) paint(parseInt(el.getAttribute('data-uc-idx'), 10));
    }

    var t = null;
    function onScroll() { clearTimeout(t); t = setTimeout(sync, SCROLL_WAIT); }
    function onResize() { clearTimeout(t); t = setTimeout(sync, RESIZE_WAIT); }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    each(dots, function (dot) {
      dot.addEventListener('click', function () {
        // Elegir un banner a mano detiene la rotacion automatica para siempre.
        if (app.__ucPause) app.__ucPause(true);
        var el = nearest(parseInt(dot.getAttribute('data-uc-go'), 10));
        if (!el) return;
        var x = posIn(el);
        if (track.scrollTo) track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' });
        else track.scrollLeft = x;
      });
    });

    // Las imagenes de los slides cambian las medidas al cargar.
    var settle = setTimeout(sync, 300);
    window.addEventListener('load', sync);

    cleaners.push(function () {
      clearTimeout(t);
      clearTimeout(settle);
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', sync);
    });
  }

  /* ---------- Cotizador ---------- */
  function bindQuoter(app, modal, appId, cleaners) {
    var opener = app.querySelector('[data-uc-open]');
    var card = modal.querySelector('.lp-qm-card');
    var steps = modal.querySelectorAll('[data-uc-step]');
    var bars = modal.querySelectorAll('.lp-qm-pd');
    var backBtn = modal.querySelector('[data-uc-back]');
    var sumEl = modal.querySelector('[data-uc-sum]');
    // Ojo: los botones del paso 1 tambien llevan data-uc-kit (el texto del kit),
    // por eso la lista del resultado usa un atributo distinto.
    var kitEl = modal.querySelector('[data-uc-kitlist]');
    var waEl = modal.querySelector('[data-uc-wa]');
    var phone = modal.getAttribute('data-uc-phone') || '';
    var intro = modal.getAttribute('data-uc-intro') || '';

    var LAST = 4;
    var cur = 1;
    var answers = {};
    var kit = '';
    var lastFocus = null;

    // moveFocus solo en transiciones que provoca el usuario: al cambiar de paso el
    // boton enfocado pasa a display:none y el foco caeria en <body>, saliendo del modal.
    function show(n, moveFocus) {
      cur = n;
      var active = null;
      each(steps, function (s) {
        if (parseInt(s.getAttribute('data-uc-step'), 10) === n) { s.classList.add('is-on'); active = s; }
        else s.classList.remove('is-on');
      });
      var filled = n > bars.length ? bars.length : n;
      each(bars, function (b, i) {
        if (i < filled) b.classList.add('is-on'); else b.classList.remove('is-on');
      });
      if (backBtn) {
        if (n > 1) backBtn.removeAttribute('hidden');
        else backBtn.setAttribute('hidden', '');
      }
      if (card) card.scrollTop = 0;
      if (n === LAST) buildResult();
      if (moveFocus && active) {
        var first = active.querySelector('[data-uc-pick], [data-uc-wa]');
        if (first) first.focus();
      }
    }

    function buildResult() {
      var chips = [], lines = [];
      for (var k = 1; k < LAST; k++) {
        if (!answers[k]) continue;
        var st = modal.querySelector('[data-uc-step="' + k + '"]');
        var key = (st && st.getAttribute('data-uc-key')) || ('Dato ' + k);
        chips.push(answers[k]);
        lines.push('• ' + key + ': ' + answers[k]);
      }
      if (sumEl) sumEl.textContent = chips.join('  ·  ');
      if (kitEl) {
        kitEl.innerHTML = '';
        var rows = String(kit || '').split(/\r?\n/);
        for (var i = 0; i < rows.length; i++) {
          var txt = rows[i].replace(/^[\s•·\-–]+/, '').trim();
          if (!txt) continue;
          var li = document.createElement('li');
          li.textContent = txt;
          kitEl.appendChild(li);
        }
      }
      if (waEl && phone) {
        var msg = lines.length ? intro + '\n\n' + lines.join('\n') : intro;
        waEl.setAttribute('href', phone + '?text=' + encodeURIComponent(msg));
      }
      track('litte_cotizador_completo', {
        necesito: answers[1] || '', propiedad: answers[2] || '', zonas: answers[3] || ''
      });
    }

    each(modal.querySelectorAll('[data-uc-pick]'), function (opt) {
      opt.addEventListener('click', function () {
        var step = parseInt(opt.getAttribute('data-uc-pick'), 10);
        var box = opt.parentNode;
        each(box.querySelectorAll('[data-uc-pick]'), function (s) { s.classList.remove('is-sel'); });
        opt.classList.add('is-sel');
        answers[step] = opt.getAttribute('data-uc-val') || '';
        if (opt.hasAttribute('data-uc-kit')) kit = opt.getAttribute('data-uc-kit') || '';
        track('litte_cotizador_paso', { paso: step, valor: answers[step] });
        if (reduce) show(step + 1, true);
        else setTimeout(function () { show(step + 1, true); }, PICK_WAIT);
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () { if (cur > 1) show(cur - 1, true); });
    }
    if (waEl) {
      waEl.addEventListener('click', function () {
        track('litte_wa_click', { origen: 'cotizador', necesito: answers[1] || '', propiedad: answers[2] || '', zonas: answers[3] || '' });
      });
    }

    /* --- abrir / cerrar --- */
    function focusables() {
      var all = modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var out = [];
      each(all, function (el) {
        if (el.hasAttribute('hidden')) return;
        if (!el.getClientRects().length) return; // descarta lo que esta en un paso oculto
        out.push(el);
      });
      return out;
    }

    function onKey(e) {
      var k = e.key || e.keyCode;
      if (k === 'Escape' || k === 'Esc' || k === 27) { e.preventDefault(); close(); return; }
      if (k !== 'Tab' && k !== 9) return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    var closeTimer = null;

    function open() {
      lastFocus = document.activeElement;
      // Al reabrir tras terminar, empieza de cero para poder cotizar otra cosa.
      if (cur === LAST) {
        answers = {}; kit = '';
        each(modal.querySelectorAll('.is-sel'), function (s) { s.classList.remove('is-sel'); });
        show(1);
      }
      track('litte_cotizador_abrir', { bloque: appId });
      clearTimeout(closeTimer);
      modal.removeAttribute('hidden');
      void modal.offsetWidth; // reflow: la transicion necesita un estado inicial pintado
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      var target = modal.querySelector('.lp-qm-x');
      if (target) target.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      clearTimeout(closeTimer); // un cierre doble dejaria un timer que oculta el modal ya reabierto
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      var hide = function () { modal.setAttribute('hidden', ''); };
      if (reduce) hide();
      else closeTimer = setTimeout(hide, CLOSE_WAIT);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);
    each(modal.querySelectorAll('[data-uc-close]'), function (c) {
      c.addEventListener('click', close);
    });

    show(1);

    cleaners.push(function () {
      clearTimeout(closeTimer);
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-uc-app]');
    for (var i = 0; i < nodes.length; i++) setupApp(nodes[i]);
  }

  window.LitteQuoter = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editor de temas: secciones que se recargan en caliente.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    var nodes = e.target.querySelectorAll('[data-uc-app]');
    for (var i = 0; i < nodes.length; i++) { if (nodes[i].__ucCleanup) nodes[i].__ucCleanup(); }
  });
})();
